import React, { useEffect, useState } from "react";
import { Modal, Button, Spin } from "antd";
import { DownloadOutlined, FileExcelOutlined } from "@ant-design/icons";
import SpecTabsView from "./SpecTabsView";
import { fetchSpecBytes } from "../../service/fsd.service";
import { parseSpecWorkbook } from "../../helper/spec_parser";

// View an already-uploaded control document by re-parsing the original
// .xlsx from its S3 URL — same tabbed view as the upload review.
function SpecViewerModal({ open, specRecord, onClose }) {
  const [loading, setLoading] = useState(false);
  const [parsed, setParsed] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!open || !specRecord?.specName) return;
    let cancelled = false;
    setParsed(null);
    setError(false);
    setLoading(true);
    fetchSpecBytes(specRecord.specName)
      .then((buf) => {
        if (!cancelled) setParsed(parseSpecWorkbook(buf));
      })
      .catch(() => {
        if (!cancelled) setError(true);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [open, specRecord]);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      width="82vw"
      style={{ top: 24 }}
      styles={{ body: { height: "70vh", overflowY: "auto", overflowX: "hidden" } }}
      destroyOnClose
      title={
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <FileExcelOutlined style={{ color: "#185FA5" }} />
          <span style={{ fontWeight: 600 }}>
            {specRecord?.specName || "Control document"}
          </span>
        </div>
      }
      footer={[
        specRecord?.s3Path ? (
          <a key="dl" href={specRecord.s3Path} target="_blank" rel="noreferrer">
            <Button icon={<DownloadOutlined />}>Download original</Button>
          </a>
        ) : null,
        <Button key="close" type="primary" onClick={onClose}>
          Close
        </Button>,
      ]}
    >
      {loading ? (
        <div style={{ padding: "80px 0", textAlign: "center" }}>
          <Spin size="large" />
        </div>
      ) : error ? (
        <div style={{ padding: "60px 16px", textAlign: "center", color: "#6B7280" }}>
          Couldn't load the document for preview. Use{" "}
          <strong>Download original</strong> to open the file directly.
        </div>
      ) : parsed ? (
        <SpecTabsView
          fileLevel={parsed.fileLevel}
          columnLevel={parsed.columnLevel}
          allowableValues={parsed.allowableValues}
        />
      ) : (
        <div style={{ padding: "60px 0", textAlign: "center", color: "#9CA3AF" }}>
          No preview available.
        </div>
      )}
    </Modal>
  );
}

export default SpecViewerModal;
